export interface AppConfig {
    azureAd: {
        clientId: string;
        tenantId: string;
        redirectUri: string;
        accessScopes: string[];
    };
    signalR: {
        negotiateUrl: string;
        hubName: string;
    };
    apiBaseUrl: string;
}

function requireHttpsEnv(key: string, fallback: string): string {
    const value = import.meta.env[key] || fallback;
    const isLocalhost = value.startsWith('http://localhost') || value.startsWith('http://127.0.0.1');
    if (!value.startsWith('https://') && !isLocalhost) {
        throw new Error(
            `[AppConfig] "${key}" must use HTTPS in non-local environments. Received: "${value}"`
        );
    }
    return value;
}

const appConfig: AppConfig = {
    azureAd: {
        clientId: import.meta.env.VITE_AZURE_AD_CLIENT_ID || 'a30a5382-4d45-4295-9474-7464bc1f9ac7',
        tenantId: import.meta.env.VITE_AZURE_AD_TENANT_ID || 'adb53b4f-b05f-4dcb-a2e1-9111380568c3',
        redirectUri: requireHttpsEnv('VITE_AZURE_AD_REDIRECT_URI', 'http://localhost:3000'),
        accessScopes: [ import.meta.env.VITE_AZURE_AD_BACKEND_SCOPE || 'api://61b65910-0350-4e1e-a949-9de81571a5c9/api.user.access']
    },
    signalR: {
        negotiateUrl: import.meta.env.VITE_SIGNALR_NEGOTIATE_URL || 'https://web-candyland-dev-eastus2-003-aug3g5g6deewb8fd.eastus2-01.azurewebsites.net/api/signalr/negotiate',
        hubName: import.meta.env.VITE_SIGNALR_HUB_NAME || 'candyland',
    },
    apiBaseUrl: import.meta.env.VITE_API_BASE_URL || 'https://web-candyland-dev-eastus2-003-aug3g5g6deewb8fd.eastus2-01.azurewebsites.net/api',
};


export default appConfig;